module.exports = __webpack_public_path__ + "media/61.e8771a0e.wav";